import { flushSync } from "react-dom";

import { publishEvent } from "./publishEvent.ts";

export const PENDING_CHANGES_REQUESTED = "PENDING_CHANGES_REQUESTED";

/**
 * Synchronously flush all uncommitted editor state to stores.
 * Uses flushSync to ensure React re-renders with the updated state
 * before the caller continues (e.g. reading the node tree for preview/publish).
 */
export const commitPendingChanges = () => {
  flushSync(() => publishEvent(PENDING_CHANGES_REQUESTED));
};
